import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from "../../../api.service";
import { NgForm } from '@angular/forms';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-principal-investigator-signature',
  templateUrl: './principal-investigator-signature.component.html',
  styleUrls: ['./principal-investigator-signature.component.scss']
})
export class PrincipalInvestigatorSignatureComponent implements OnInit {
  @ViewChild('form') form!: NgForm;
  folderName: any;
  formName: string = 'principal-investigator-signature'; // Form name
  queryParams: any = {}; // To store query parameters
  formData: any = {
    piSignature: '', // Principal Investigator's Signature
    piSignatureDate: '' // Date of PI Signature
  };

  // Mapping questions to form fields
  private questionMapping: { [key: string]: { question: string, field: string }[] } = {
    'principal-investigator-signature': [
  { question: '1. Principal Investigator’s Signature:', field: 'investigatorSignature' },
  { question: '2. Date:', field: 'piSignatureDate' }
]
  };

  studyId: string | null = null; // Study ID
  subjectId: string | null = null; // Subject ID
  studyCode: any; // Study Code
  studyName: any; // Study Name
  siteLocation: any; // Site Location
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  subjectName: string | null;
 
//query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: { threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] }[] = [
  {  threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end
//edit thing
isPrincipal1Disabled: boolean = false;
  isPrincipal2Disabled: boolean = false;
  isReasonModalOpen       = false;    
editReason              = '';  
//review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
     private commonService: CommonService
  ) {}

  ngOnInit(): void {
    const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);

  const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);
  this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize
  

    console.log('ngOnInit Executed');
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;
  
    this.informedConsentDate = ''; // Start with an empty value
    this.screeningMinDate = ''; // Same for screeningMinDate
  
    // Get the formName parameter from the route
    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'principal-investigator';;
      this.formName = params['formName'];
      console.log('Form Name:', this.formName,'folder name',this.folderName); // Debugging log
   this.checkAndCallApi();
    });

    // Get query parameters (studyId and subjectId)
    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
      console.log('Study ID:', this.studyId); // Debugging log
      console.log('Subject ID:', this.subjectId); // Debugging log
      this.checkAndCallApi();
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });
  }
    checkAndCallApi(){
    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
           // Ensure response.data is an array before mapping
           if (Array.isArray(response.data)) {
            this.mapFormData(response.data);
          } else {
            console.warn('Form data is not an array or is missing.');
          }
          this.mapStudyDetails(response.studyDetails);

          // Dynamically update informedConsentDate from the response
          if (response.informedConsentDate !== undefined) {
            this.informedConsentDate = response.informedConsentDate;
            this.screeningMinDate = this.informedConsentDate;  // Set min date
            console.log("Informed Consent Date:", this.informedConsentDate);
          } else {
            console.warn('Informed consent date is missing in the response.');
          }
           // Store the gender from the response
           this.gender = response.gender;
           console.log("gender:",this.gender);
        }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    const fieldName = this.fieldLabel || 'Unknown Field';
  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
  }
  // Function to map study details
 mapStudyDetails(studyDetails: any): void {
  if (studyDetails) {
    // Check if studyDetails has the expected properties
    this.studyCode = studyDetails.study_code ?? 'N/A';  // Default to 'N/A' if study_code is undefined
    this.studyName = studyDetails.study_name ?? 'Unknown Study';  // Default to 'Unknown Study' if study_name is undefined
    this.siteLocation = studyDetails.site_location ?? 'Unknown Location';  // Default to 'Unknown Location' if site_location is undefined
    this.subjectName = this.subjectId;  // Mapping subjectId to subjectName
    
    console.log("Mapped Study Details:", {
      studyCode: this.studyCode,
      studyName: this.studyName,
      siteLocation: this.siteLocation,
      subjectName: this.subjectName,
    });
    
  } else {
    console.warn('Study details are missing or undefined.');
  }
}
 updateEndDateRange(log: any) {
    if (log.startDate) {
      log.endDate = ''; // Clear previously selected end date if any
    }
  }
/*Query functions*/

 addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}


  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
       
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
  if (selected.type === 'fieldHistory') {
    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Field History for:', fieldName);
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }

}

  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  this.showReviewModal = true;

  const fieldName = this.fieldLabel || 'Unknown Field';
  console.log('Opening Review Modal - Fetching Field History for:', fieldName);

  this.apiService.getInsertHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Field History Data (from review modal):', response);
      this.fieldHistoryData = response.data || [];

      // Initialize default review flags
      let latestReview = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      // Sort descending by updated_at to get the latest ones first
      const sortedData = [...this.fieldHistoryData].sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());

      const flagsFound = {
        dataMonitor: false,
        monitor: false,
        pi: false
      };

      for (const entry of sortedData) {
        if (!entry.review_status) continue;

        try {
          const parsed = JSON.parse(entry.review_status);

          // For each reviewer type, only update if not already found (i.e., get the latest one)
          if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
            latestReview.dataMonitor = parsed.dataMonitor;
            flagsFound.dataMonitor = true;
          }

          if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
            latestReview.monitor = parsed.monitor;
            flagsFound.monitor = true;
          }

          if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
            latestReview.pi = parsed.pi;
            flagsFound.pi = true;
          }

          // If all found, stop early
          if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
            break;
          }

        } catch (err) {
          console.error("Error parsing review_status JSON:", err);
        }
      }

      this.reviewOptions = latestReview;
      console.log("✅ Final reviewOptions applied:", this.reviewOptions);
    },

    error: (error) => {
      console.error('Error fetching field history data from review modal:', error);
    }
  });
}


closeReviewModal() {
  this.showReviewModal = false;
}
openOptionsModal(event: MouseEvent, target: EventTarget | null): void {
  event.stopPropagation();
  this.isOptionsModalOpen = true;

  const icon = target as HTMLElement;

  // First try to find element with data-label directly
  let fieldGroup = icon.closest('[data-label]');

  // If not found, look for form-check[data-label] inside the form-group
  if (!fieldGroup) {
    const formGroup = icon.closest('.form-group');
    if (formGroup) {
      fieldGroup = formGroup.querySelector('.form-check[data-label]');
    }
  }

  if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}



openModal() {
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'

  // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
  const fieldName = this.fieldLabel || 'Unknown Field';
 console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this
 

  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);


const query = {
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         

          return query;
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });
}


getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}

submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }



reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}


// Flags to indicate presence of data
hasInvestigatorSignatureData = false;
hasPiSignatureDateData = false;

mapFormData(data: any[]): void {
  // Reset flags and review checkboxes
  this.hasInvestigatorSignatureData = false;
  this.hasPiSignatureDateData = false;

  this.reviewOptions = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  data.forEach(item => {
    const fieldName = item.field_name?.trim();
    const fieldValue = item.value;

    // ✅ Review checkbox values
    if (fieldName === 'reviewedByDataMonitor') {
      this.reviewOptions.dataMonitor = fieldValue === 'true';
    }
    if (fieldName === 'reviewedByMonitor') {
      this.reviewOptions.monitor = fieldValue === 'true';
    }
    if (fieldName === 'reviewedByPI') {
      this.reviewOptions.pi = fieldValue === 'true';
    }

    // ✅ PI Signature form fields with flags
    switch (fieldName) {
      case '1. Principal Investigator’s Signature:':
        this.formData.investigatorSignature = fieldValue;
        this.hasInvestigatorSignatureData = !!fieldValue;
        this.isPrincipal1Disabled = !!fieldValue;
        break;

      case '2. Date:':
        this.formData.piSignatureDate = fieldValue;
        this.hasPiSignatureDateData = !!fieldValue;
        this.isPrincipal2Disabled = !!fieldValue;
        break;
    }
  });
}

editStudy() {
  if (this.fieldLabel === '1. Principal Investigator’s Signature:' && this.formData.investigatorSignature) {
    this.isReasonModalOpen = true;
  } else if (this.fieldLabel === '2. Date:' && this.formData.piSignatureDate) {
    this.isReasonModalOpen = true;
  } 
   else {
    // First time - no need to ask}
     if (this.fieldLabel === '1. Principal Investigator’s Signature:') {
      this.isPrincipal1Disabled = false;
    } else if (this.fieldLabel === '2. Date:') {
      this.isPrincipal2Disabled = false;
    }
}
}
confirmEditReason() {
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }
  if (this.fieldLabel === '1. Principal Investigator’s Signature:') {
    this.isPrincipal1Disabled = false;
  } else if (this.fieldLabel === '2. Date:') {
    this.isPrincipal2Disabled = false;
  }
  this.isReasonModalOpen = false;
}

cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}
  // Function to handle form submission
  submitForm() {
    let questionAnswers: { [key: string]: any } = {};
  
    if (this.formName && this.questionMapping[this.formName]) {
      this.questionMapping[this.formName].forEach(mapping => {
        let fieldKey = mapping.question;
  
       if (this.formName === 'principal-investigator-signature') {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        } else {
          questionAnswers[fieldKey] = this.formData[mapping.field];
        }
        
        if (mapping.field === 'piSignatureDate') {
                console.log('Edit Reason for field:', this.editReason);
    questionAnswers[fieldKey] = {
      answer: this.formData[mapping.field],
      editReason: this.editReason || '', // Include edit reason if provided
            reviewStatus: { ...this.reviewOptions }
            }
          } 
          else if (mapping.field === 'investigatorSignature'){
              console.log('Edit Reason for field:', this.editReason);
    questionAnswers[fieldKey] = {
      answer: this.formData[mapping.field],
      editReason: this.editReason || '', // Include edit reason if provided
      reviewStatus: { ...this.reviewOptions }    }}
     
    
    
     });
    }
    const submittedData = {
      folderName: "principal-investigator",
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
      ...questionAnswers
    };
  
    console.log("Form Submitted:", submittedData);
  
    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Form Submitted Successfully!");
         this.isPrincipal1Disabled=true;
         this.isPrincipal2Disabled=true;
          this.editReason = '';
      },
      error: (error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      }
    });
  }
  
  insertFormData(submittedData: { folderName: string | null; formName: string | null; studyId: string | null; subjectId: string | null; }) {
    throw new Error('Method not implemented.');
  }
  
  // Function to navigate back
  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }
   //new + import line to allow. closing of panel
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
    if (!clickedInside) {
      this.isOptionsModalOpen = false;
    }
  }
}